
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[partner]",
      function () {
        return require("private-next-pages/partners/[partner].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[partner]"])
      });
    }
  